import styled from "styled-components"

import {LatoBold} from "@irati/ui/src/global/fonts"

export const AvailableBalance = styled.span`
  ${LatoBold}
`
